module.exports = __webpack_public_path__ + "img/appAsset--metrics-branch-ax.5f496814.svg";